import { WhatSelected } from '../../../../context/TopicsSubTopics';

// Определяет выделен ли именно этот узел в дереве топиков и суб-топиков
export function nodeIsSelected(nodeId, isRoot, isSelected, whatSelected) {
    if (nodeId === isSelected) {
        switch (whatSelected) {
            case WhatSelected.TOPIC:
                if (isRoot === 'true') {
                    return true;
                }
                break;
            case WhatSelected.SUBTOPIC:
                if (isRoot === 'false') {
                    return true;
                }
                break;
        }
    }
    return false;
}